import { applyMiddleware, compose, createStore } from 'redux'
import createSagaMiddleware from 'redux-saga'
import rehydrateState from './rehydrate-state'
import rootReducer from './modules'
import sagas from './sagas'

export default function configureStore(initialState = {}) {
  const rehydratedState = rehydrateState(initialState)
  const sagaMiddleware = createSagaMiddleware()

  const store = createStore(
    rootReducer,
    rehydratedState,
    compose(
      applyMiddleware(sagaMiddleware),
      (typeof window !== 'undefined' &&
        window.__REDUX_DEVTOOLS_EXTENSION__ &&
        (process.env.NODE_ENV === 'development' ||
          location.host.includes('localhost')))
        ? window.__REDUX_DEVTOOLS_EXTENSION__()
        : f => f,
    ),
  )

  // run the available sagas
  sagaMiddleware.run(sagas)

  return store
}
